import React from "react";

export default function LoadingPage() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
      {/* Loader Spinner */}
      <div className="relative w-24 h-24 mb-4">
        <div className="absolute inset-0 border-4 border-black rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute inset-0 border-4 border-black border-t-transparent rounded-full animate-spin"></div>
      </div>
      {/* Loading Text */}
      <p className="text-black text-2xl font-semibold tracking-widest opacity-80 animate-fadeIn">
        Carregando...
      </p>
    </div>
  );
}

/* Tailwind CSS Animations */
<style>
  {`
    @keyframes fadeIn {
      0% { opacity: 0; transform: translateY(20px); }
      100% { opacity: 1; transform: translateY(0); }
    }

    .animate-fadeIn {
      animation: fadeIn 1.2s ease-out;
    }
  `}
</style>;
